import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '@/api/firebaseClient';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

const EntornoContext = createContext(null);

const ENTORNO_DOC = 'entorno_activo';
const SETTINGS_COL = 'settings';

export function EntornoProvider({ children }) {
  const [entorno, setEntorno] = useState('produccion'); // 'pruebas' | 'produccion'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to Firestore in real-time so all users are synced
    const ref = doc(db, SETTINGS_COL, ENTORNO_DOC);
    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setEntorno(snap.data().valor || 'produccion');
      }
      setLoading(false);
    }, () => {
      setLoading(false); // on error, default to produccion
    });
    return () => unsub();
  }, []);

  const setEntornoActivo = async (nuevoEntorno) => {
    const ref = doc(db, SETTINGS_COL, ENTORNO_DOC);
    await setDoc(ref, {
      clave: 'entorno_activo',
      valor: nuevoEntorno,
      descripcion: 'Entorno activo del sistema (pruebas | produccion)',
      updated_date: new Date().toISOString(),
    });
  };

  return (
    <EntornoContext.Provider value={{
      entorno,
      isPruebas: entorno === 'pruebas',
      isProduccion: entorno === 'produccion',
      setEntornoActivo,
      loading,
    }}>
      {children}
    </EntornoContext.Provider>
  );
}

export function useEntorno() {
  const ctx = useContext(EntornoContext);
  if (!ctx) throw new Error('useEntorno must be used within EntornoProvider');
  return ctx;
}
